import React from "react";

export const CheckIcon = ({ width, height, color }) => (
  <svg xmlns="https://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
    width={width ? width : "24px"}
    height={height ? height : "24px"}
    viewBox="0 0 13 10">
    <defs>
      <clipPath id="a"><path className="a" d="M0,0H13V10H0Z" /></clipPath>
    </defs>
    <g className="b">
      <path d="M3.439,9.56l-3-3A1.5,1.5,0,0,1,2.561,4.439L4.5,6.379,10.439.439a1.5,1.5,0,1,1,2.122,2.122l-7,7a1.5,1.5,0,0,1-2.122,0Z"
        fill={color ? color : "#6f9e32"}
      />
    </g>
  </svg>
);
